import styled from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import { HTMLAttributes } from 'react';

type LazyImageProps = {
  src: string;
  placeholderSrc?: string;
  alt?: string;
}
export function LazyImage({ src, placeholderSrc, alt }: LazyImageProps) {
  return (
    <LazyLoadImage
      src={src}
      placeholderSrc={placeholderSrc}
      style={{ width: "100%", flex: "1 2 100px", minWidth: "100px", display: "block", maxWidth: "100%" }}
      alt={alt}
    />
  )
}

interface IContainer extends HTMLAttributes<HTMLDivElement>{
  $noMargin?: boolean
}

export const ImageContainer = styled.div<IContainer>`
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;
  grid-column: 3/-3;
  flex-wrap: wrap;
  gap: var(--gap);
  margin-bottom: ${props => props.$noMargin ? "0" : "var(--gap)"};

   @media (max-width: 1200px) {
      max-height: 450px;
   }
    
  @media (max-width: 450px) {
    flex-direction: column;
  }
`;

export const ImageDummy = styled.div`
  flex: 1 2 100px;

  @media (max-width: 450px) {
    display: none;;
  }
`;
